//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DialogCard from '../../../../components/dialogAlert';
import ScrollArea from '../scrollArea/index.vue';
import { x24icclose, x16icclose } from '../../../../icons';

export default ({
  components: {
    ScrollArea,
    x24icclose,
    x16icclose,
  },
  extends: DialogCard,
  // дополнительные свойства и методы
  data() {
    return {
      className: 'dialog-card',
    };
  },
});
